'use strict';
/** family: Dropdown **/
var __extends =
	(this && this.__extends) ||
	(function () {
		var extendStatics = function (d, b) {
			extendStatics =
				Object.setPrototypeOf ||
				({ __proto__: [] } instanceof Array &&
					function (d, b) {
						d.__proto__ = b;
					}) ||
				function (d, b) {
					for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
				};
			return extendStatics(d, b);
		};
		return function (d, b) {
			extendStatics(d, b);
			function __() {
				this.constructor = d;
			}
			d.prototype =
				b === null
					? Object.create(b)
					: ((__.prototype = b.prototype), new __());
		};
	})();
var __assign =
	(this && this.__assign) ||
	function () {
		__assign =
			Object.assign ||
			function (t) {
				for (var s, i = 1, n = arguments.length; i < n; i++) {
					s = arguments[i];
					for (var p in s)
						if (Object.prototype.hasOwnProperty.call(s, p))
							t[p] = s[p];
				}
				return t;
			};
		return __assign.apply(this, arguments);
	};
var __rest =
	(this && this.__rest) ||
	function (s, e) {
		var t = {};
		for (var p in s)
			if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
				t[p] = s[p];
		if (s != null && typeof Object.getOwnPropertySymbols === 'function')
			for (
				var i = 0, p = Object.getOwnPropertySymbols(s);
				i < p.length;
				i++
			)
				if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
		return t;
	};
Object.defineProperty(exports, '__esModule', { value: true });
var classNames = require('classnames');
var keycode = require('keycode');
var React = require('react');
var Backdrop_1 = require('../Backdrop');
var DropdownItem_1 = require('../DropdownItem');
var Scrollable_1 = require('../Scrollable');
var utils_1 = require('../utils');
/**
 * Aria roles this dropdown supports.
 */
var DropdownRole;
(function (DropdownRole) {
	DropdownRole['ListBox'] = 'listbox';
	DropdownRole['Menu'] = 'menu';
})((DropdownRole = exports.DropdownRole || (exports.DropdownRole = {})));
var getEffectiveRole = function (dropdownRole) {
	switch (dropdownRole) {
		case DropdownRole.ListBox:
			return DropdownItem_1.DropdownItemRole.Option;
		case DropdownRole.Menu:
			return DropdownItem_1.DropdownItemRole.MenuItem;
	}
};
/**
 * Dropdowns are used to select an option from a limited result set.
 *
 * Please also see where dropdown is used in other components
 * - see {{AutoComplete}}, {{Dropdown#DropdownButton}}, {{MultiSelect#MultiSelectButton}}
 * and {{MultiSelect#MultiSelectList}}.
 */
var Dropdown = /** @class */ (function (_super) {
	__extends(Dropdown, _super);
	function Dropdown(props) {
		var _this = _super.call(this, props) || this;
		/**
		 * Handles basic keyboard navigation,
		 * i.e.: navigation that doesn't trigger actions, like arrow keys and escape.
		 * @param {React.KeyboardEvent<HTMLElement>} e
		 */
		_this.handleBasicKeyboardNavigation = function (e) {
			var activeItemIndex = _this.state.activeItemIndex;
			if (e.keyCode === keycode.codes.esc) {
				activeItemIndex = -1;
				if (_this.props.onOutsideClick) {
					_this.props.onOutsideClick(e);
				}
				if (_this.props.onClose) {
					_this.props.onClose();
				}
				_this.deselectAll();
				return;
			}
			var dropdownItemProps;
			var items = React.Children.toArray(_this.props.children);
			do {
				if (e.keyCode === keycode.codes.down) {
					if (activeItemIndex < items.length - 1) {
						activeItemIndex++;
					}
					e.preventDefault();
				} else if (e.keyCode === keycode.codes.up) {
					if (activeItemIndex > 0) {
						activeItemIndex--;
					}
					e.preventDefault();
				}
				if (activeItemIndex === -1) {
					return;
				}
				var nextActiveItem = items[activeItemIndex];
				if (
					utils_1.isType(nextActiveItem, DropdownItem_1.DropdownItem)
				) {
					dropdownItemProps = nextActiveItem.props;
				}
			} while (
				dropdownItemProps &&
				(dropdownItemProps.divider || dropdownItemProps.disabled)
			);
			_this.setActiveItem(activeItemIndex);
		};
		_this.handleBackdropClick = function (e) {
			if (_this.props.isOpen) {
				_this.deselectAll();
				if (_this.props.onOutsideClick) {
					_this.props.onOutsideClick(e);
				}
				e.stopPropagation();
			}
		};
		// For the dropdown menu, return its visible viewport
		// If any of its parents have overflow: hidden set,
		// then the dropdown will be cut off if its height exceeds it
		// hence that element forms the visible viewport.
		_this.getVisibleViewport = function () {
			var p = _this.dropdownMenu.parentElement;
			while (p) {
				var style = window
					.getComputedStyle(p)
					.getPropertyValue('overflow');
				if (style === 'hidden') {
					break;
				}
				p = p.parentElement;
			}
			return p;
		};
		_this.handleKeyDown = function (e, onKeyDown) {
			_this.handleBasicKeyboardNavigation(e);
			if (onKeyDown) {
				onKeyDown(e);
			}
		};
		_this.handleClick = function (e, onClick) {
			_this.props.onSelect && _this.props.onSelect(e);
			onClick && onClick(e);
		};
		_this.setActiveItem = function (activeItemIndex) {
			_this.setState({
				activeItemIndex: activeItemIndex,
			});
		};
		_this.deselectAll = function () {
			_this.setState({
				activeItemIndex: -1,
			});
		};
		_this.handleKeyDownForContainer = function (e) {
			if (React.Children.count(_this.props.children) === 0) {
				return;
			}
			_this.handleBasicKeyboardNavigation(e);
		};
		_this.renderMenuItem = function (menuitem, key, active) {
			var _a = menuitem.props,
				anchorRef = _a.anchorRef,
				onClick = _a.onClick,
				onKeyDown = _a.onKeyDown,
				role = _a.role,
				restProps = __rest(_a, [
					'anchorRef',
					'onClick',
					'onKeyDown',
					'role',
				]);
			var effectiveRole = role
				? role
				: getEffectiveRole(_this.props.role);
			return React.createElement(
				DropdownItem_1.DropdownItem,
				__assign({ active: active, role: effectiveRole }, restProps, {
					anchorRef: function (e) {
						if (active && e) {
							e.focus();
						}
						if (anchorRef) {
							anchorRef(e);
						}
					},
					key: key,
					onKeyDown: function (e) {
						return _this.handleKeyDown(e, onKeyDown);
					},
					onClick: function (e) {
						return _this.handleClick(e, onClick);
					},
				})
			);
		};
		_this.renderDropdownMenu = function (items, id) {
			return React.createElement(
				Scrollable_1.Scrollable,
				{
					'aria-labelledby': id,
					role: _this.props.role.valueOf(),
					className: classNames(
						'dropdown-menu',
						'i-dropdown__menu',
						'show',
						{
							'dropdown-menu-right': _this.props.rightAlign,
						}
					),
					style: __assign({}, _this.state.style, _this.props.style),
					scrollableRef: function (el) {
						return (_this.dropdownMenu = el);
					},
				},
				React.Children.map(items, function (item, index) {
					return (
						item &&
						_this.renderMenuItem(
							item,
							index,
							_this.state.activeItemIndex === index
						)
					);
				})
			);
		};
		_this.dynamicResizeDropdown = function (upperHeight, lowerHeight) {
			// it won't fit anyway,
			// make the best of a bad situation and find the best size.
			var buffer = 16;
			// determine which orientation can fit more content.
			if (upperHeight > lowerHeight) {
				_this.setState(function (prevState) {
					return {
						isDropUp: true,
						style: __assign({}, prevState.style, {
							height: upperHeight - buffer + 'px',
						}),
					};
				});
			} else {
				_this.setState(function (prevState) {
					return {
						isDropUp: false,
						style: __assign({}, prevState.style, {
							height: lowerHeight - buffer + 'px',
						}),
					};
				});
			}
		};
		_this.state = {
			activeItemIndex: -1,
		};
		return _this;
	}
	Dropdown.getDerivedStateFromProps = function (props, state) {
		if (!props.isOpen && (state.isDropUp != null || state.style != null)) {
			// Clear isDropUp and style from state on close
			// so that it will be recalculated
			// if the window size or scroll position changes.
			return {
				activeItemIndex: state.activeItemIndex,
				isDropUp: null,
				style: null,
			};
		} else {
			return null;
		}
	};
	Dropdown.prototype.componentDidUpdate = function () {
		var _this = this;
		// Make sure we render the dropdown in the correct position
		if (
			this.props.isOpen &&
			this.props.isDropUp == null &&
			this.dropdownMenu
		) {
			var visibleViewport = this.getVisibleViewport();
			// if there is an element with overflow hidden set,
			// that element defines the bounds of the dropdownMenu
			// else the top is the window top which is 0 and bottom
			// is the bottom of the window which is its innerHeight
			var viewportRect_1 = visibleViewport
				? visibleViewport.getBoundingClientRect()
				: {
						bottom: window.innerHeight,
						top: 0,
						width: window.innerWidth,
				  };
			var dropdownRect = this.dropdownMenu.getBoundingClientRect();
			var containerRect =
				this.dropdownMenu.parentElement.getBoundingClientRect();
			// If the dropdown is wider than the visible viewport, we need to constrict it.
			if (
				dropdownRect.width > viewportRect_1.width &&
				(this.state.style == null ||
					(this.state.style.left == null &&
						this.state.style.right == null &&
						this.state.style.width == null))
			) {
				var viewportStyle =
					visibleViewport && window.getComputedStyle(visibleViewport);
				if (viewportStyle) {
					// If the visible viewport is positioned absolutely or relatively
					// then we can simply set left/right values.
					// Else we need to calculate the width ourselves.
					if (
						viewportStyle.position === 'absolute' ||
						viewportStyle.position === 'relative'
					) {
						this.setState(function (prevState) {
							return {
								style: __assign({}, prevState.style, {
									left: _this.props.rightAlign
										? 0
										: undefined,
									right: !_this.props.rightAlign
										? 0
										: undefined,
								}),
							};
						});
					} else {
						var padding_1 =
							parseInt(viewportStyle.paddingLeft, 10) +
							parseInt(viewportStyle.paddingRight, 10);
						this.setState(function (prevState) {
							return {
								style: __assign({}, prevState.style, {
									width:
										viewportRect_1.width - padding_1 + 'px',
								}),
							};
						});
					}
				}
			}
			var upperHeight = containerRect.top - viewportRect_1.top;
			// sometimes the window element continues past the visible area
			// when that happens we still don't want the dropdown to exceed
			// the window height
			var lowerHeight =
				Math.min(viewportRect_1.bottom, window.innerHeight) -
				containerRect.bottom;
			// If isDropUp has been set, it means we've been through this before.
			// It should be safe to render now.
			if (this.state.isDropUp != null) {
				return;
			}
			if (dropdownRect.height < lowerHeight) {
				return;
			} else if (dropdownRect.height < upperHeight) {
				this.setState({
					isDropUp: true,
				});
			} else {
				this.dynamicResizeDropdown(upperHeight, lowerHeight);
			}
		}
	};
	Dropdown.prototype.render = function () {
		var dropup = (this.state && this.state.isDropUp) || this.props.isDropUp;
		var classes = classNames(
			'dropdown',
			'i-dropdown',
			this.props.className,
			{
				dropup: dropup,
				show: this.props.isOpen,
			}
		);
		var itemsToRender =
			this.props.isOpen &&
			this.renderDropdownMenu(this.props.children, this.props.id);
		return React.createElement(
			'div',
			{
				id: this.props.id,
				onKeyDown: this.handleKeyDownForContainer,
				className: classes,
				tabIndex: -1,
			},
			this.props.toggle,
			this.props.onOutsideClick &&
				React.createElement(Backdrop_1.Backdrop, {
					active: this.props.isOpen,
					onClick: this.handleBackdropClick,
					zIndex: 1000 - 1,
				}),
			this.props.isOpen && itemsToRender
		);
	};
	Dropdown.Item = DropdownItem_1.DropdownItem;
	Dropdown.Role = DropdownRole;
	return Dropdown;
})(React.Component);
exports.Dropdown = Dropdown;
//# sourceMappingURL=Dropdown.js.map
